// IMAGES
function setupImages() {
  const swiper = new Swiper("#na-product-images", {
    direction: "horizontal",
    keyboard: {
      enabled: true,
    },
    autoHeight: true,
    // autoplay: {
    //   delay: 3000,
    // },
    centeredSlides: true,
    slidesPerView: "1",
    loop: false,
    grabCursor: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "bullets",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  const imageTagArr = document.querySelectorAll(".na-image__group img");
  imageTagArr.forEach((imageTag, key) => {
    imageTag.addEventListener("click", (e) => {
      imageTagArr.forEach((imageTag) => {
        imageTag.classList.remove("active");
      });
      swiper.slideTo(key + 1);
      e.target.classList.add("active");
    });
  });
}

function setupInfo() {
  const incrementBtn = document.getElementById("increment-bq");
  const decrementBtn = document.getElementById("decrement-bq");
  const input = document.getElementById("buy-quantity");
  incrementBtn.addEventListener("click", (e) => {
    input.value = parseInt(input.value) + 1;
    return false;
  });
  decrementBtn.addEventListener("click", (e) => {
    input.value = Math.max(parseInt(input.value) - 1, 1);
    return false;
  });
  input.addEventListener("input", (e) => {
    const value = e.target.value;
    input.value = value.toString().replace(/[^0-9]+/, "");
  });

  const prodBuyEl = document.querySelector(".na-info__buy");
  const prodBuyBtnEl = prodBuyEl.querySelector(".na-info__buy .add");
  const prodQuantityEl = document.getElementById("buy-quantity");
  const errorEl = document.querySelector(".na-info__error");

  const addons = document.getElementsByName("addon");

  if (prodBuyBtnEl && prodBuyEl && prodQuantityEl) {
    prodBuyBtnEl.addEventListener("click", () => {
      const { pid, title, quantity, boxComplimentaryId, boxLeatherId, boxOriginalId } = prodBuyEl.dataset;
      const input_quantity = parseInt(prodQuantityEl.value);
      let box_id = boxComplimentaryId || null;

      for (let addon of addons) {
        if (addon.checked) {
          if (addon.value == "leather") {
            box_id = boxLeatherId || null;
          } else if (addon.value == "original") {
            box_id = boxOriginalId || null;
          }
        }
      }

      if (!isNaN(input_quantity) && input_quantity <= quantity) {
        addToBag(pid, input_quantity, box_id)
          .then(() => triggerPopup({ message: title, status: "tick" }))
          .then(() => {
            prodQuantityEl.value = "1";
            errorEl.innerText = "";
          });
      } else {
        errorEl.innerText =
          "Only " + quantity + " items left for this article!";
        prodQuantityEl.value = quantity;
      }
    });
  }
}

setupImages();
setupInfo();
